<div *ngIf="openExitDialog"
  class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div class="cancelDialog">
      <p class="font-bold z-10">Sure you want to leave?</p>
      <p class="mt-3 z-10">Your changes are not saved automatically and will be discarded if you exit now. Make sure to
        save your changes before you exit.</p>
      <fa-icon class="mt-3 z-10" [icon]="faTriangleExclamation" size="5x"></fa-icon>
      <div class="h-[38px] mt-5 flex flex-row z-10">
        <full-button [marginRight]="true" (click)="openExitDialog = false" text="Cancel" />
        <outline-button (click)="userManagementMenu()" text="Exit Now" />
      </div>
      <fa-icon class="backgroundExit" [icon]="faTriangleExclamation" size="10x"></fa-icon>
    </div>
  </div>
</div>
@if(openAssignDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div
      class="absolute flex flex-col gap-2 shadow rounded-[16px] bg-white h-fit max-h-[90vh] w-[450px] m-auto top-0 bottom-0 left-0 right-0 p-5 text-left">
      <p class="font-bold z-10">{{assignRoleDetails?.name}} optional context</p>
      @if (subjectList.length !== 0 || unitList.length !== 0) {
      <p class="text-sm mt-2">
        Add <b>only one</b> of the four contexts from below. The contexts work top down, meaning if you assign a role at
        the organization level they will also have that role for each context (the subjects, units, and courses) that
        reside underneath it.
        <br /><br />
        The contexts reside underneath each other in this order. organization > subject > unit > course.
      </p>
      }
      @if (organizationList.length !== 0) {
      <div>
        <p class="mt-3 text-sm font-medium pb-1">Organization</p>
        <dropdown-search [items]="organizationList" [addedList]="addedOrganizationList" [singleItemList]="true"
          placeholder="Choose organization" [isOrganization]="true"
          [disabled]="addedSubjectList.length > 0 || addedUnitList.length > 0" />
        <chip *ngFor="let org of addedOrganizationList; let i = index" [text]="org.name != undefined? org.name:''"
          (click)="addedOrganizationList = []" />
      </div>
      }
      @if (subjectList.length !== 0) {
      <div>
        <p class="mt-3 text-sm font-medium pb-1">Subjects</p>
        <dropdown-search [items]="subjectList" [addedList]="addedSubjectList" [singleItemList]="true"
          placeholder="Choose subjects" [isSubject]="true"
          [disabled]="addedOrganizationList.length > 0 || addedUnitList.length > 0" />
        <chip *ngFor="let addedSubject of addedSubjectList; let i = index"
          [text]="addedSubject.name != undefined? addedSubject.name:''" (click)="addedSubjectList = []" />
      </div>
      }
      @if (unitList.length !== 0) {
      <div>
        <p class="mt-3 text-sm font-medium pb-1">Units</p>
        <dropdown-search [items]="unitList" [addedList]="addedUnitList" [singleItemList]="true"
          placeholder="Choose units" [isUnit]="true"
          [disabled]="addedSubjectList.length > 0 || addedOrganizationList.length > 0" />
        <chip *ngFor="let addedUnit of addedUnitList; let i = index"
          [text]="addedUnit.name != undefined? addedUnit.name: ''" (click)="addedUnitList = []" />
      </div>
      }
      <div class="flex justify-end mt-6">
        <outline-button [marginRight]="true" (click)="openAssignDialog = false" text="Cancel" />
        <full-button (click)="saveOptionalDetails(assignRoleDetails?.role_id)" text="Save Changes" />
      </div>
    </div>
  </div>
</div>
}
<save-popup message="User Created!" [show]="saveDialog" />
<error-dialog [error]="errorMessage" [show]="showErrorDialog" />
<!-- TODO need a form and dirty check before navigating away -->
<breadcrumb endText="New User" [navigations]="breadcrumbNavs" />
<div class="m-8">
  <h1 class="font-semibold text-xl">
    Create New User
  </h1>
  <div class="text-sm mb-8 mt-2 text-zinc-500">
    This form is designed to help you create a new user and assign user to any role.
    <br />Please fill out the following fields with the relevant information for the new user.
    <br />Required fields are marked with an asterisk <span class="text-red-500">(*)</span>. Please ensure that the
    information you provide is accurate and up to date.
  </div>
  <div [formGroup]="userForm" class="grid grid-cols-3 gap-x-4 gap-y-5 items-start lg:w-[50%]">
    <label for="firstName" class="font-semibold pt-2">First Name<span class="text-red-500">*</span></label>
    <div class="col-span-2 flex flex-col">
      <input formControlName="firstName" id="firstName" placeholder="First Name" class="input w-full"
        [(ngModel)]="firstName" />
      @if (firstNameValidation) {
      <p class="text-xs text-red-500 font-semibold mt-2">First name is required.</p>
      }
    </div>
    <label for="lastName" class="font-semibold pt-2">Last Name<span class="text-red-500">*</span></label>
    <div class="col-span-2 flex flex-col">
      <input formControlName="lastName" id="lastName" placeholder="Last Name" class="input w-full"
        [(ngModel)]="lastName" />
      @if (lastNameValidation) {
      <p class="text-xs text-red-500 font-semibold mt-2">Last name is required.</p>
      }
    </div>
    <label for="netID" class="font-semibold pt-2">NetID<span class="text-red-500">*</span></label>
    <div class="col-span-2 flex flex-col">
      <input formControlName="netID" id="netID" placeholder="NetID" class="input w-full" [(ngModel)]="username" />
      @if (usernameValidation) {
      <p class="text-xs text-red-500 font-semibold mt-2">NetID is required.</p>
      }
    </div>
    <label for="email" class="font-semibold pt-2">Primary Email<span class="text-red-500">*</span></label>
    <div class="col-span-2 flex flex-col">
      <input formControlName="email" id="email" placeholder="Primary Email" class="input w-full"
        [(ngModel)]="email" />
      @if (emailValidation) {
      <p class="text-xs text-red-500 font-semibold mt-2">Primary Email is required.</p>
      }
    </div>
    <label for="ruid" class="font-semibold pt-2">RUID</label>
    <input formControlName="ruid" id="ruid" placeholder="RUID" class="col-span-2 input w-full" [(ngModel)]="ruid" />
    <label for="schoolCode" class="font-semibold pt-2">School Code</label>
    <input formControlName="school_code" id="schoolCode" placeholder="School Code" class="col-span-2 input w-full"
      [(ngModel)]="school_code" />
    <label for="admitCode" class="font-semibold pt-2">Admit Code</label>
    <input formControlName="admit_code" id="admitCode" placeholder="Admit Code" class="col-span-2 input w-full"
      [(ngModel)]="admit_code" />
    <label class="font-semibold pt-2">Initial Role<span class="text-red-500">*</span></label>
    <div class="col-span-2 flex flex-col">
      <!-- TODO change to a single role so that the subjects and units for role UX is simpler -->
      <dropdown-search [items]="roleList" [addedList]="addedRoleList" [singleItemList]="true"
        placeholder="Search for roles" />
      <!-- TODO Let this be a more detailed type of chip, onclick opens the dialog to add the subjects and units -->
      @if (addedRoleList.length !== 0) {
      <div class="flex items-center text-xs border rounded-[4px] mt-1 py-1 px-0.5">
        <button (click)="addedRoleList = removeItemFromList(addedRoleList[0], addedRoleList)"
          class="hover:bg-gray-200 rounded-full p-0.5 w-6 h-6 mr-1" aria-label="Remove Role">
          <fa-icon [icon]="faXmark" />
        </button>
        <div class="flex-grow">
          {{addedRoleList[0].name}}
        </div>
        <button (click)="openAssignClick(addedRoleList[0].role_id, addedRoleList[0].subjects, addedRoleList[0].units)"
          class="hover:bg-gray-200 rounded-full p-0.5 w-6 h-6" aria-label="Open Role Dialog">
          <fa-icon [icon]="faChevronRight" />
        </button>
      </div>
      }
      @if (roleValidation) {
      <p class="text-xs text-red-500 font-semibold mt-2">At least one role is required.</p>
      }
    </div>
    <div class="col-span-3 flex flex-row justify-end">
      <outline-button [marginRight]="true" (click)="_location.back()" text="Cancel" />
      <full-button (click)="createUser()" text="Create User" />
    </div>
  </div>
</div>
